import * as ko from "knockout";
import {IMessageData, IObjectData, IRouteDefinitionParams} from '../../../index';
import {createErrorMessage} from "../../../util/misc";
import {nsRoute} from "../../../util/route";
import {REQUEST_MESSAGE} from "../../../constants/Language";
import {nsUserSyncfields} from "@component/user/syncfields/nsUserSyncfields";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import AbstractSyncfieldsHtml from './AbstractSyncfields.html?raw';

export const tpl = AbstractSyncfieldsHtml

export abstract class AbstractSyncfields extends ParsedRouteDataDecorator {
    protected readonly abstract def: nsUserSyncfields.ICard[]
    protected isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    protected messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    protected object!: IObjectData;
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.init();
    }

    protected init() {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        this.__requestRouteData!
            .request()
            .then((data: IObjectData[]) => this.onSuccess(data))
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
            });
    }

    protected onSuccess(data: IObjectData[]) {
        const object = data[0];
        if (!object) {
            return;
        }
        this.object = object;
        this.messageData(null);
        this.isReady(true);
    }
}
